import { HelmetProvider } from 'react-helmet-async';

import { DataProvider } from '@utils/useData';
import { IntlProvider } from '@utils/useIntl';
import Router from './Router';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import '@style/main.css';

const App = () => (
  <HelmetProvider>
    <IntlProvider>
      <DataProvider>
        <Router />
      </DataProvider>
    </IntlProvider>
  </HelmetProvider>
);

export default App;
